module.exports = __webpack_public_path__ + "static/img/kefu.e50af89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kefu.png
// module id = 7vTl
// module chunks = 1